import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import WalletProviders from './WalletProviders.js';
import reportWebVitals from './reportWebVitals.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WalletProviders>
      <App />
    </WalletProviders>
  </React.StrictMode>
);

reportWebVitals();